// External Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import {
  blueGrey500,
} from 'material-ui/styles/colors';

// Internal Dependencies
// import Fade from 'shared/transitions/fade';

// Local Variables
const propTypes = {
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
};

const defaultProps = {
  backgroundColor: '',
  children: null,
  title: '',
};

const defaultRootStyles = {
  alignItems: 'center',
  backgroundColor: blueGrey500,
  borderRadius: '2px 2px 0 0',
  color: 'white',
  display: 'flex',
  flex: 'none',
  fontSize: '24px',
  height: 64,
  justifyContent: 'space-between',
  padding: '0 4px 0 24px',
};

const titleIconsStyles = {
  alignItems: 'center',
  display: 'flex',
  flex: 'none',
  height: 48,
};

const titleTextStyles = {
  flex: 'none',
};

// Component Definition
const TitleBar = (props) => {
  const {
    backgroundColor,
    children,
    // isLoading,
    title,
  } = props;

  // Don't render anything if there's no title
  if (!title) return null;

  const rootStyles = backgroundColor
    ? { ...defaultRootStyles, backgroundColor }
    : defaultRootStyles;

  return (
    <div style={rootStyles}>
      <div style={titleTextStyles}>{title}</div>
      <div style={titleIconsStyles}>
        {/* <Fade in={isLoading}> */}
        {/* </Fade> */}
        {children}
      </div>
    </div>
  );
};

TitleBar.propTypes = propTypes;
TitleBar.defaultProps = defaultProps;
export default TitleBar;



/** WEBPACK FOOTER **
 ** ./src/shared/main-content-container/title-bar.js
 **/